module.exports = __webpack_public_path__ + "static/media/pic02.656c6927.gif";